import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexRow, Text } from '../misc';
import Tip from '../../images/tip';

export const Wrapper = styled(FlexRow)`
  padding: ${themeGet('space.4')}px 0;
`;

export const StyledTip = styled(Tip)`
  > g {
    fill: ${themeGet('colors.red')};
  }
`;

export const TipText = styled(Text)`
  padding-left: ${themeGet('space.3')}px;
  font-size: 14px;
  flex: 0 0 90%;

  @media screen and (min-width: 72em) {
    font-size: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/tip/style.js